/* eslint-disable i18next/no-literal-string */

import { useQuery } from '@tanstack/react-query'
import { useUserId } from '~/components/user/SessionProvider'
import { trpc } from '~/lib/trpc'

export function assetDetailsQueryKey(userId: string, assetId: string) {
  return [userId, 'assetDetails', assetId]
}

export function useAssetDetails(assetId: string) {
  const userId = useUserId()

  return useQuery({
    ...trpc.property.getAssetDetails.queryOptions({ assetId }),
    enabled: !!userId && !!assetId,
  })
}
